/**
 * DevExtreme (esm/exporter/jspdf/export_gantt.js)
 * Version: 22.2.15
 * Build date: Mon Feb 10 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
function exportGantt(options) {
    var component = options.component;
    return null === component || void 0 === component ? void 0 : component.exportToPdf(options)
}
export {
    exportGantt
};
